import { useEffect, useRef } from 'react'

const CursorGlow = () => {
	const glowRef = useRef(null)

	useEffect(() => {
		const move = (e) => {
			if (glowRef.current) {
				// Use transform for GPU-accelerated movement (no re-renders)
				glowRef.current.style.transform = `translate(${e.clientX - 500}px, ${e.clientY - 500}px)`
			}
		}
		window.addEventListener('mousemove', move)
		return () => window.removeEventListener('mousemove', move)
	}, [])

	return (
		<div
			ref={glowRef}
			className='fixed top-0 left-0 pointer-events-none z-0 w-[1000px] h-[1000px] rounded-full'
			style={{
				background:
					'radial-gradient(circle, rgba(59,130,246,0.05) 0%, rgba(6,182,212,0.02) 40%, transparent 70%)',
				willChange: 'transform',
			}}
		/>
	)
}

export default CursorGlow
